import type { PartMovementEvent } from '@avisoma/shared';
import { SourcePageCell } from './SourcePageCell';
import { Td, Th, TruncatedTd } from './cells';
import { FindingMarkerCell, FindingMarkerHeader, type RowFindings } from './FindingMarkerCell';
import {
  extractionRowClass,
  extractionTableClass,
  extractionTbodyClass,
  extractionTheadClass,
} from './tableClasses';

type PartMovementRow = PartMovementEvent & { pageId?: string };

export function PartMovementTable({
  rows,
  pageIdToPosition,
  onInspect,
  rowFindings,
}: {
  rows: PartMovementRow[];
  pageIdToPosition?: Map<string, number>;
  onInspect: (row: PartMovementRow, index: number) => void;
  rowFindings?: RowFindings;
}) {
  return (
    <table className={extractionTableClass}>
      <thead className={extractionTheadClass}>
        <tr>
          {rowFindings && <FindingMarkerHeader />}
          {pageIdToPosition && <Th>Page</Th>}
          <Th>Type</Th>
          <Th>Date</Th>
          <Th>ESN</Th>
          <Th>MSN</Th>
          <Th>TSN</Th>
          <Th>CSN</Th>
          <Th>Thrust</Th>
          <Th>A/C</Th>
          <Th>Operator</Th>
          <Th>Position</Th>
          <Th>Reason</Th>
        </tr>
      </thead>
      <tbody className={extractionTbodyClass}>
        {rows.map((r, i) => (
          <tr
            key={`${r.pageId}-${i}`}
            onClick={() => onInspect(r, i)}
            className={extractionRowClass}
          >
            {rowFindings && <FindingMarkerCell findings={rowFindings.get(i)} />}
            {pageIdToPosition && (
              <Td>
                <SourcePageCell pageId={r.pageId} pageIdToPosition={pageIdToPosition} />
              </Td>
            )}
            <Td>{r.type}</Td>
            <Td>{r.date ?? '—'}</Td>
            <Td className="font-mono">{r.esn ?? '—'}</Td>
            <Td className="font-mono">{r.msn ?? '—'}</Td>
            <Td>{r.tsn ?? '—'}</Td>
            <Td>{r.csn ?? '—'}</Td>
            <Td>{r.thrust ?? '—'}</Td>
            <Td>{r.aircraftReg ?? '—'}</Td>
            <TruncatedTd value={r.operator} maxWidth="max-w-[200px]" />
            <Td>{r.position ?? '—'}</Td>
            <TruncatedTd value={r.reason} />
          </tr>
        ))}
      </tbody>
    </table>
  );
}
